import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import {Paper,Grid} from '@material-ui/core';
// import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { fontFamily,fontSizes,colors} from '../../styles/variables'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const reviewflag = require('../../images/reviewflag.png');
const tutorialSteps = [
  {
    label: '“love it, always wonderful site…. USE THIS SITE FOR SCREEN RECORDING PEOPLE PEOPLE!!!!!!!! “',
    imgPath:reviewflag,
    clientName:'Mathew J',
  },
  {
    label: '“USE THIS SITE FOR SCREEN RECORDING PEOPLE PEOPLE!!!!!!!! “',
    imgPath:reviewflag,
    clientName:'Tom J',
 },
  {
    label: 'love it, always wonderful site…. USE THIS SITE FOR SCREEN RECORDING',
    imgPath:reviewflag,
    clientName:'Robet J',
  },
  {
    label: '“love it, always wonderful site…. USE THIS SITE FOR SCREEN RECORDING"',
    imgPath:reviewflag,
    clientName:'Leese J',
  },
  {
    label: '“love it, always wonderful site…. PEOPLE PEOPLE!!!!!!!! “',
    imgPath:reviewflag,
    clientName:'Jerry J',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 400,
    // width:'80%',
    display:'flex',
    justifyContent:'center',
    flexGrow: 1,
    flexDirection:'column',
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.paper,
  },
  img: {
    height: 50,
    display: 'flex',
    justifyContent:'center',
    // maxWidth: 800,
    overflow: 'hidden',
    width: '10%',
  },
    paper: {
        height: 350,
        width: 550,
        borderRadius:19,
        boxShadow:'0px 0px 40px #0C207219',
        paddingBottom:10,
        marginTop:50,
        '@media only screen and (max-width: 1024px)': {
        //   marginLeft:'7%',
          marginBottom:'5%',
          width: '80%',
          height: '60%',
          marginTop:0,
          // maxWidth: "62%",
        },
    },
    paperContainer:{
        display:'flex',
        justifyContent:'center',
        marginBottom:'2rem',
        //  marginTop:'-4em',
        // marginLeft:'8em',
        // marginRight:'5em',
        '@media only screen and (max-width: 1024px)': {
          display:'flex',
          justifyContent:'center',
          margin:0,
          marginTop:0,
        }
    },
    itemDescription:{
        fontFamily:fontFamily.poppins,
        fontSize:fontSizes.md.small,
        fontWeight:'bolder',
        textAlign:'center',
        color: colors.black,
        lineHeight: 2,
        paddingTop:60,
        paddingLeft:30,
        paddingRight:30,
        // overflow:'hidden',
        height:90
    },
    reviwFlagImageDiv:{
        display:'flex',
        paddingTop:100,
        paddingBottom:10,
        justifyContent:'center',
        alignContent:'center',
    },
    reviwFlagImage:{
        width:60,
        justifyContent:'center',
        objectFit:'contain'
    },
    itemHeading:{
        fontFamily:fontFamily.poppins,
        fontSize:25,
        fontWeight:'normal',
        textAlign:'center',
        color:'black',
    },
  maindiv:{
      width:400,
      display:'flex',
      justifyContent:'center'
  },
  mobileStepper:{
     '&.MuiMobileStepper-dotActive':{
      backgroundColor: colors.red,
    },
    
    '&.MuiMobileStepper-root':{
        backgroundColor: colors.white,
        "&$active": {
          color: "green"
        },
        "&$completed": {
          color: "red"
        }
    },
   
  }
}));

function SwipeableTextMobileStepper() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  return (
    <div className={classes.root}>
    <Grid item spacing={4} className={classes.paperContainer}>
    <Paper className={classes.paper}>
      <div className={classes.itemDescription}>{tutorialSteps[activeStep].label}</div>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {tutorialSteps.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
                <div className={classes.reviwFlagImageDiv}>
              <img src={step.imgPath} alt={step.label} className={classes.reviwFlagImage} />
              </div>
            ) : null}
          </div>
        ))}
        
      </AutoPlaySwipeableViews>

      <div className={classes.itemHeading}>{tutorialSteps[activeStep].clientName}</div>
      </Paper>
      </Grid>
      <MobileStepper
        className={classes.mobileStepper}
        steps={maxSteps}
        position="static"
        variant="dots"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                     </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
          
          </Button>
        }
      />
    </div>
  );
}
  {/*  <img className={classes.img} src={step.imgPath} alt={step.label} /> */}
export default SwipeableTextMobileStepper;
